<template>
  <div class="pa-4">
    <h1>Deep Cloning Object in JavaScript</h1>
    <CodeHighlight :code="code" />
  </div>
</template>

<script>
import CodeHighlight from '@/modules/codehl/CodeHighlight.vue';


export default {
  components: {
    CodeHighlight,
  },
  data() {
    return {
    code: `_.cloneDeep(obj)
structuredClone(obj)`,
    }
  },

  methods: {
  },
}
</script>

<style scoped>

</style>